import axios from "axios";
import { getToken } from "./AuthService";

// const BASE_REST_API_URL = 'http://localhost:8080/api/metadata';
const BASE_REST_API_URL = 'http://159.89.182.193:8080/api/metadata';

// Add a request interceptor
axios.interceptors.request.use(function (config) {
    config.headers['Autorization'] = getToken();
    return config;
}, function (error) {
    // Do something with request error
    return Promise.reject(error);
});

export const getMetadata = (name) => axios.get(BASE_REST_API_URL + '/name/' + name)
export const updateMetadata = (name, metadata) => axios.put(BASE_REST_API_URL + '/name/' + name, metadata)

